import { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";

const POLL_INTERVAL_MS = 15000;

/**
 * PendingActivationPage
 *
 * Purpose: Shown by ProtectedRoute in place of the app when the signed-in
 * user's status is "Pending" (they signed in via SSO with no matching
 * account and are awaiting admin approval). Polls /api/v1/auth/me so access
 * appears automatically once approved, without a re-login.
 */
function PendingActivationPage() {
  const { user, refreshMe, logout } = useAuth();
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setChecking(true);
      refreshMe().finally(() => setChecking(false));
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [refreshMe]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-page px-4 py-10 text-text-secondary">
      <section className="mx-auto w-full max-w-md rounded-lg border border-border bg-surface-raised p-6 text-center shadow-sm">
        <h1 className="text-2xl font-semibold text-text-primary">Awaiting Approval</h1>
        <p className="mt-3 text-sm leading-6 text-text-secondary">
          You&apos;re signed in as <strong>{user?.email}</strong>, but an
          administrator still needs to approve your account before you can
          access the portal. This page updates automatically once you&apos;re
          approved.
        </p>
        {checking && (
          <p className="mt-2 text-xs text-text-faint">Checking status…</p>
        )}
        <button
          type="button"
          onClick={logout}
          className="mt-6 rounded-md border border-border-input px-4 py-2 text-sm text-text-secondary hover:border-accent"
        >
          Sign out
        </button>
      </section>
    </main>
  );
}

PendingActivationPage.propTypes = {};

export default PendingActivationPage;
